import React from 'react';
import AdminLayout from './AdminLayout';
import TagManagementTab from '../../components/TagManagementTab';

export default function AdminTagsPage() {
    return (
        <AdminLayout title="Tags" description="Manage tags for contacts and accounts">
            <TagManagementTab />
        </AdminLayout>
    );
}
